import {post} from "../modules/ajax";
import EmblaCarousel from "embla-carousel";
import {onVisible} from "../../scripts/Tools/visible-element-observer";
import {isMobile} from "../modules/devices";

let variableName = '_tv_last_viewed_products';
let maxProducts = 20;

export function renderLastViewedProductsBlock(container)
{
    post(
        '/ajax/website/product-list/get-last-viewed-products-recommender',
        {lastViewedProducts: getLastViewedProducts()},
        function(data) {
            if (data.recommender === '') {
                container.remove();
                return;
            }
            container.innerHTML = data.recommender;

            onVisible(container.querySelectorAll('.recommender'), function (recommender) {
                initLastViewedProductsRecommender(recommender);
            }, 0.1);
        }
    );
}

export function initLastViewedProductsRecommender(recommender)
{
    let emblaContainer = recommender.closest('.embla-container');
    let emblaPrevButton = emblaContainer.querySelector('.embla-prev-button');
    let emblaNextButton = emblaContainer.querySelector('.embla-next-button');
    let emblaPaginator = emblaContainer.querySelector('.embla-pagination');
    let numberOfSlides = recommender.querySelectorAll('.embla-slide').length;
    let emblaCarousel = EmblaCarousel(
        recommender,
        {
            loop: numberOfSlides > 2,
            align: "start",
            breakpoints: {
                '(min-width: 768px)': {
                    loop: numberOfSlides > 5,
                    slidesToScroll: 'auto'
                },
                '(min-width: 1200px)': {
                    loop: false
                }
            },
        }
    );

    let imageHeight = recommender.querySelector('img').offsetHeight;
    let arrowTop = imageHeight / 2;
    emblaPrevButton.style.top = arrowTop + "px";
    emblaNextButton.style.top = arrowTop + "px";

    if (!isMobile()) {
        if (emblaCarousel.canScrollPrev()) emblaPrevButton.classList.remove('d-none');
        if (emblaCarousel.canScrollNext()) emblaNextButton.classList.remove('d-none');
    }

    emblaPrevButton.addEventListener('click', emblaCarousel.scrollPrev, false);
    emblaNextButton.addEventListener('click', emblaCarousel.scrollNext, false);

    emblaCarousel.on('select', function() {
        let previousSlideIndex = emblaCarousel.previousScrollSnap();
        let nextSlideIndex = emblaCarousel.selectedScrollSnap();
        emblaPaginator.querySelector(`.embla-pagination-element[data-slide-index="${previousSlideIndex}"]`).classList.remove('bg-black');
        emblaPaginator.querySelector(`.embla-pagination-element[data-slide-index="${previousSlideIndex}"]`).classList.add('bg-gray-light');
        emblaPaginator.querySelector(`.embla-pagination-element[data-slide-index="${nextSlideIndex}"]`).classList.remove('bg-gray-light');
        emblaPaginator.querySelector(`.embla-pagination-element[data-slide-index="${nextSlideIndex}"]`).classList.add('bg-black');
    });

    //LAZYLOAD FUNCTIONALITY
    let slidesLoaded = [];
    emblaCarousel.on('slidesInView', function() {
        let slidesInView = emblaCarousel.slidesInView().filter((index) => !slidesLoaded.includes(index));

        slidesInView.forEach(function(slideIndex) {
            let slide = emblaCarousel.slideNodes()[slideIndex];
            if (!slide) return;
            let img = slide.querySelector('img');
            let loader = slide.querySelector('.loader');

            img.src = img.dataset.src;
            img.addEventListener('load', function() {
                loader.classList.add('d-none');
                slidesLoaded.push(slideIndex);
            });
        });
    });
}

export function addLastViewedProduct(reference)
{
    let lastViewedProducts = JSON.parse(localStorage.getItem(variableName)) || [];
    if (!lastViewedProducts.includes(reference)) lastViewedProducts.push(reference);
    if (lastViewedProducts.length > maxProducts) lastViewedProducts.shift();
    localStorage.setItem(variableName, JSON.stringify(lastViewedProducts));
}

export function getLastViewedProducts()
{
    return JSON.parse(localStorage.getItem(variableName));
}